import { render, staticRenderFns } from "./TariffModal.vue?vue&type=template&id=279f01d6&scoped=true&"
import script from "./TariffModal.vue?vue&type=script&lang=js&"
export * from "./TariffModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279f01d6",
  null
  
)

export default component.exports